import { CareerProps } from "../types/career.type";

export const schoolCareer:CareerProps[] = [
    {
        step: 1,
        postTitle: 'Cycle ingénieur en informatique',
        orgUrl: 'https://www.3il-ingenieurs.fr/',
        organization: '3il ingénieur',
        period: 'Sept. 2025 - Maint.', 
        skills: 'Collaboration, science de l\'ingénieur, Github, Architecture des ordinateurs/Systèmes, Analyse et conception de base de donnée, C avancé, bases du web, réseau.',
    },
    {
        step: 2,
        postTitle: 'Classe préparatoire intégrée',
        orgUrl: 'https://myiuc.com/',
        organization: 'Institut universitaire de la côte',
        period: 'Oct. 2023 - Mai 2025', 
        skills: 'Collaboration, science de l\'ingénieur (Mécanique, Electronique), science humaine, Méthode UML, git & github',        
    }
]